/**
 * Bee Hive — cart attribution entry point.
 * Reads ?ref= (and bee_hive_ref / utm_partner), persists bee_hive_ref in localStorage,
 * and POSTs /cart/update.js { attributes: { bee_hive_ref } }.
 *
 * Works with muskle-bee-hive-partner-state.js + muskle-bee-hive-cart-ref.js (load order in scripts.liquid).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'bee_hive_ref';
  var ATTR = 'bee_hive_ref';
  var DEBOUNCE_MS = 300;

  function sanitize(raw) {
    if (raw == null) return '';
    var s = String(raw).trim().toLowerCase().replace(/[^a-z0-9_-]/g, '');
    return s || '';
  }

  function readUrlRef() {
    try {
      var sp = new URLSearchParams(window.location.search);
      var raw = sp.get('ref') || sp.get('bee_hive_ref') || sp.get('utm_partner');
      return sanitize(raw);
    } catch (e) {
      return '';
    }
  }

  function persistRef(ref) {
    if (!ref) return;
    try {
      localStorage.setItem(STORAGE_KEY, ref);
    } catch (e) {
      /* ignore */
    }
    try {
      sessionStorage.setItem(STORAGE_KEY, ref);
    } catch (e2) {
      /* ignore */
    }
  }

  function readStoredRef() {
    try {
      var ls = localStorage.getItem(STORAGE_KEY);
      if (ls && String(ls).trim()) return sanitize(ls);
    } catch (e) {
      /* ignore */
    }
    try {
      var ss = sessionStorage.getItem(STORAGE_KEY);
      if (ss && String(ss).trim()) return sanitize(ss);
    } catch (e2) {
      /* ignore */
    }
    return '';
  }

  function resolveRef() {
    if (window.MuskleBeeHivePartner && window.MuskleBeeHivePartner.isDemoPartnerRoute()) {
      return '';
    }
    var urlRef = readUrlRef();
    if (urlRef) {
      persistRef(urlRef);
      return urlRef;
    }
    if (window.MuskleBeeHivePartner) {
      var active = window.MuskleBeeHivePartner.getActivePartner();
      if (active && active.ref) return sanitize(active.ref);
    }
    return readStoredRef();
  }

  function getCartUpdateUrl() {
    if (typeof window.Theme !== 'undefined' && window.Theme.routes && window.Theme.routes.cart_update_url) {
      return window.Theme.routes.cart_update_url;
    }
    return '/cart/update.js';
  }

  var debounceTimer = null;

  function pushToCart(ref) {
    if (!ref) return;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js');
        return res.json();
      })
      .then(function (cart) {
        var attrs = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
        var existing = attrs[ATTR] != null ? String(attrs[ATTR]).trim() : '';
        if (existing === ref) return;

        var merged = {};
        for (var k in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, k)) {
            merged[k] = attrs[k];
          }
        }
        merged[ATTR] = ref;

        return fetch(getCartUpdateUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ attributes: merged }),
        });
      })
      .catch(function () {
        /* silent */
      });
  }

  function sync() {
    debounceTimer = null;
    var ref = resolveRef();
    if (!ref) return;
    pushToCart(ref);
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, DEBOUNCE_MS);
  }

  window.BeeHiveAttribution = {
    storageKey: STORAGE_KEY,
    cartAttribute: ATTR,
    sanitize: sanitize,
    readUrlRef: readUrlRef,
    readStoredRef: readStoredRef,
    resolveRef: resolveRef,
    sync: sync,
  };

  function bind() {
    var urlRef = readUrlRef();
    if (urlRef) persistRef(urlRef);
    sync();
    document.addEventListener('cart:update', scheduleSync);
    document.addEventListener('muskle-bee-hive-partner-changed', scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
